import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ILoyaltyBalance } from "../../models/Loyalty";
import { LoyaltyService } from "../../services/loyalty.service";

export const useGetLoyaltyPointBalanceQuery = (userId: string | null) => {
  return useQuery<ILoyaltyBalance, Error>({
    queryKey: [QUERY_CONSTANTS.GET_LOYALTY_POINT_BALANCE, userId],
    queryFn: () => LoyaltyService.getBalance(userId).then((res) => res.data),
    enabled: !!userId,
  });
};
